"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "menconico": {
    "ac147512": [{
      "hkey": "8a212ce8",
      "slug": "menconico",
      "name": "Menconico",
      "primary": true,
      "skipSearch": false
    }],
    "carpeneto": [{
      "hkey": "8a212ce8",
      "slug": "menconico",
      "name": "Menconico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "49dbfcac": [{
      "hkey": "8a212ce8",
      "slug": "menconico",
      "name": "Menconico",
      "primary": true,
      "skipSearch": false
    }],
    "ghiareto": [{
      "hkey": "8a212ce8",
      "slug": "menconico",
      "name": "Menconico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bf3f2cf6": [{
      "hkey": "8a212ce8",
      "slug": "menconico",
      "name": "Menconico",
      "primary": true,
      "skipSearch": false
    }],
    "lago": [{
      "hkey": "8a212ce8",
      "slug": "menconico",
      "name": "Menconico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b483c284": [{
      "hkey": "78ca1da6",
      "slug": "mulino-san-pietro",
      "name": "Mulino San Pietro",
      "primary": true,
      "skipSearch": false
    }],
    "molino-san-pietro": [{
      "hkey": "78ca1da6",
      "slug": "mulino-san-pietro",
      "name": "Mulino San Pietro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9cda3b42": [{
      "hkey": "8a212ce8",
      "slug": "menconico",
      "name": "Menconico",
      "primary": true,
      "skipSearch": false
    }],
    "pineta": [{
      "hkey": "8a212ce8",
      "slug": "menconico",
      "name": "Menconico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "286a660c": [{
      "hkey": "8a212ce8",
      "slug": "menconico",
      "name": "Menconico",
      "primary": true,
      "skipSearch": false
    }],
    "residenza": [{
      "hkey": "8a212ce8",
      "slug": "menconico",
      "name": "Menconico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;